/* CO2-theme.js
   Small, dependency-free behaviors shared by CO2.*.liquid sections.
   Accordions (FAQ, how-to-use) and tabs (results-timeline) are pure CSS
   (details/summary and radio inputs) and need no JS. Carousels reuse the
   theme's already-bundled Flickity, auto-initialized globally by the
   theme for any ".flickityt4s" element - no extra init code needed here.
*/
(function(){
  document.addEventListener('click', function(e){
    var stepBtn = e.target.closest('[data-co2-qty-step]');
    if (stepBtn) {
      var wrap = stepBtn.closest('[data-co2-qty]');
      if (!wrap) return;
      var input = wrap.querySelector('input[type="number"], input[name="quantity"]');
      if (!input) return;
      var step = parseInt(stepBtn.getAttribute('data-co2-qty-step'), 10);
      var min = parseInt(input.getAttribute('min') || '1', 10);
      var value = (parseInt(input.value, 10) || min) + step;
      if (value < min) value = min;
      input.value = value;
      input.dispatchEvent(new Event('change', { bubbles: true }));
      return;
    }

    var scrollLink = e.target.closest('.co2-scroll-link');
    if (scrollLink) {
      var targetId = scrollLink.getAttribute('href');
      if (targetId && targetId.charAt(0) === '#') {
        var target = document.querySelector(targetId);
        if (target) {
          e.preventDefault();
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }
      return;
    }

    var thumb = e.target.closest('[data-co2-gallery-thumb]');
    if (thumb) {
      var gallery = thumb.closest('[data-co2-gallery]');
      if (!gallery) return;
      var index = thumb.getAttribute('data-index');
      gallery.querySelectorAll('[data-co2-gallery-thumb]').forEach(function(el){
        el.classList.toggle('is-active', el === thumb);
      });
      gallery.querySelectorAll('[data-co2-gallery-slide]').forEach(function(el){
        el.classList.toggle('is-active', el.getAttribute('data-index') === index);
      });
    }
  });
})();
